import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function MoreTestimonials() {
  const testimonials = ['Volví a entrenar después de ser mamá. Y sin pensar qué hacer cada día.', 'En 3 semanas ya tenía más energía. El sistema me ordenó la vida.', 'Lo mejor: no tengo que pensar nada. Solo seguir.', 'Bajé de peso sin volverme loca.', 'Me siento otra persona.'];
  return <section className="py-6 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-192">
      <div className="text-center mb-4" data-id="element-193">
        <h2 className="font-display text-xl md:text-2xl font-bold flex items-center justify-center gap-2 text-gray-900" data-id="element-194">
          <span className="text-brand-danger" data-id="element-195">❤️</span> MÁS MAMÁS QUE YA LO
          TIENEN
        </h2>
      </div>

      <div className="space-y-3" data-id="element-196">
        {testimonials.map((text, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08
      }} className="bg-white/80 border border-pink-200 rounded-xl p-4 flex flex-col md:flex-row items-center gap-3 text-center md:text-left justify-center md:justify-start shadow-sm" data-id="element-197">
            <div className="flex gap-0.5 flex-shrink-0" data-id="element-198">
              {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-accent text-brand-accent" data-id="element-199" />)}
            </div>
            <p className="text-base text-gray-600 font-medium italic" data-id="element-200">
              "{text}"
            </p>
          </motion.div>)}
      </div>
    </section>;
}